import { SERVER_ENDPOINT } from '../helpers';
import {
	fetchGetCountries,
} from './index';

export const getCountriesByContinent = async (region) => {
	return await fetchGetCountries(
		`https://restcountries.com/v3.1/region/${region}?fields=name,continents,idd,independent`,
	);
};